import { Box, List, ListItem, Typography, useTheme } from "@mui/material";
import { Element } from "react-scroll";

import batteryImageUrl from "@/assets/images/article/battery.png";
import batteryThumbnailUrl from "@/assets/images/article/battery_thumbnail.png";
import {
  conclusion,
  introduction,
  resourcesFirstPart,
  resourcesList,
  resourcesSecondPart,
} from "./data/staticData";

import AnimatedImage from "@/components/UI-Kit/AnimatedImage";
import Heading from "./components/Heading";
import Text from "./components/Text";
import { getQuoteStyles, listStyles } from "./styles";

const Content = () => {
  const theme = useTheme();

  return (
    <>
      <Box component={Element} name="Introduction" mb={{ xs: 4, md: 7 }}>
        <Heading title="Introduction" />
        <Box display="flex" flexDirection="column" gap={{ xs: 2, md: 3 }}>
          {introduction.map((text, index) => (
            <Text key={index} text={text} />
          ))}
        </Box>
      </Box>

      <Box
        component={Element}
        name="Software and tools"
        mb={{ xs: 4, md: 6.75 }}
      >
        <AnimatedImage
          sx={{
            borderRadius: "20px",
            mb: { xs: 4, md: 7.5 },
            img: { width: "100%", height: "auto", objectFit: "contain" },
          }}
          thumbnailUrl={batteryThumbnailUrl}
          mainUrl={batteryImageUrl}
          alt="battery"
        />
        <Box sx={getQuoteStyles(theme)}>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            fontSize={{ xs: "1rem", md: "1.25rem", lg: "1.25rem" }}
            mb={{ xs: 3, md: 4 }}
          >
            “In a world older and more complete than ours they move finished and
            complete, gifted with extensions of the senses we have lost or never
            attained, living by voices we shall never hear.”
          </Typography>
          <Typography color="text.secondary">
            — Olivia Rhye, Product Designer
          </Typography>
        </Box>
      </Box>

      <Box component={Element} name="Other resources" mb={{ xs: 4, md: 6.75 }}>
        <Heading title="Other resources" />

        <Box display="flex" flexDirection="column" gap={{ xs: 2, md: 3 }}>
          {resourcesFirstPart.map((text, index) => (
            <Text key={index} text={text} />
          ))}

          <List disablePadding sx={listStyles}>
            {resourcesList.map((text, index) => (
              <ListItem key={index} disablePadding>
                <Box display="flex" gap={1}>
                  <Text text={`${index + 1}. `} />
                  <Text text={text} />
                </Box>
              </ListItem>
            ))}
          </List>

          {resourcesSecondPart.map((text, index) => (
            <Text key={index} text={text} />
          ))}
        </Box>
      </Box>

      <Box component={Element} name="Conclusion">
        <Heading title="Conclusion" />
        <Box display="flex" flexDirection="column" gap={{ xs: 2, md: 3 }}>
          {conclusion.map((text, index) => (
            <Text key={index} text={text} />
          ))}
        </Box>
      </Box>
    </>
  );
};

export default Content;
